<div class="m-t-1" fxLayout="row" fxLayoutGap="1rem">
	<div fxFlex fxLayoutAlign="start center">
		<mat-form-field fxFlex>
			<mat-label>Task Status</mat-label>
			<mat-select (selectionChange)="statusFilterChanged()" [(ngModel)]="statusFilterModel">
				<mat-option *ngFor="let filter of statusFilter" [value]="filter.type">
					{{ filter.label }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<div fxFlex fxLayoutAlign="end center" fxLayoutGap="1rem">
		<app-task-actions
			(deleteMultipleTasks)="deleteTasks()"
			(updateTasksEvent)="updateTasks($event)"
			[disabled]="selectedTasksIds.length == 0"
			[projectId]="projectId"
			[selectedTasks]="selectedTasks"
		>
		</app-task-actions>
	</div>
</div>

<div class="m-t-1" fxLayout="row" fxLayoutGap="1rem">
	<app-task
		(newAddedTask)="taskAdded($event)"
		[addTask]="true"
		[carrierDTO]="carrier"
		[displayAddButton]="false"
		[displayInputText]="true"
		[projectDTO]="projectDTO"
		[userAssignedToCarrier]="userAssignedToCarrier"
		fxFlex
	></app-task>
</div>

<mat-progress-bar *ngIf="isLoading || isRequestInProgress" mode="indeterminate"></mat-progress-bar>
<div class="m-t-1 p-0-5 font-size-12 label-text-light" fxLayoutAlign="end center">
	Shift + Click to multi-select
</div>
<div class="list-container" style="margin-top: 5px !important">
	<div (wheel)="onScroll()">
		<div *ngFor="let task of tasksList; trackBy: trackItem">
			<mat-card
				(click)="cardClicked(task, $event)"
				[ngClass]="{ 'card-selected mat-elevation-z4': selectedTasksIds.indexOf(task.id) > -1 }"
				class="m-t-1 p-0-5 mat-elevation-z1"
			>
				<span class="selection" matTooltip>
					<mat-icon>check_circle</mat-icon>
				</span>

				<mat-card-content class="font-size-14">
					<div class="padding-0-5 font-size-15" fxLayout="row" fxLayoutGap="0.5rem">
						<span class="primary-light-color">{{ task.title }}</span>
					</div>
					<div class="padding-0-5" fxLayout="row" fxLayoutGap="1rem">
						<div fxFlex>
							<span class="font-weight-700 label-text-light">Status: </span>
							<span class="label-text-light">{{ task.status }}</span>
						</div>
						<div fxFlex>
							<span class="font-weight-700 label-text-light">Due: </span>
							<span class="label-text-light">{{ task.dueDate }}</span>
						</div>
						<div *ngIf="isAdminOrOwner" fxFlex>
							<span class="font-weight-700 label-text-light">Rep: </span>
							<div class="label-text-light ellipsis" fxFlex>{{ task.assigneeName }}</div>
						</div>
					</div>
					<div class="padding-0-5" fxLayout="row" fxLayoutGap="1rem">
						<div fxFlex>
							<span class="font-weight-700 label-text-light">Project: </span>
							<span class="label-text-light">{{ task.projectName }}</span>
						</div>
					</div>
					<div class="padding-0-5" fxLayout="row">
						<div fxFlex>
							<span class="font-weight-700 label-text-light">Carrier: </span>
							<span class="label-text-light">{{ task.carrierName || '-' }}</span>
						</div>
					</div>
					<div fxLayout="row">
						<div
							*ngIf="taskService.isTaskNotDeletable(task, userId)"
							fxFlex
							fxLayoutAlign="end center"
						>
							<mat-icon
								class="task-lock-icon"
								matTooltip="Non-deletable"
								matTooltipPosition="below"
							>
								lock
							</mat-icon>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
	<div *ngIf="isListEmpty()" class="m-t-1 p-0-5 m-t-1" fxLayoutAlign="center center">No tasks.</div>
</div>
